<ideal-item-result-list [ids]="filteredIds()" />
